import React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { Download } from "@mui/icons-material"; // Import the Download icon
import AddIcon from '@mui/icons-material/Add';


type ClickHandler = () => void;
type ButtonType =
  | "BrandGradient"
  | "SmallBrandGradient"
  | "BlueFixed"
  | "SmallBlueFixed"
  | "Secondary"
  | "Outlined"
  | "SmallOutlined"
  | "AddNew";

interface CustomButtonProps {
  clickHandler: ClickHandler;
  type: ButtonType;
  label?: string;
  disabled?: boolean;
  parent_page?: string;
  className?: string; 
}

const CustomButton: React.FC<CustomButtonProps> = ({
  clickHandler,
  type,
  label,
  disabled = false,
  parent_page,
  className
}) => {
  const theme = useTheme();

  const getButtonStyle = () => {
    let buttonStyle: React.CSSProperties = {
      width: "120px",
      height: "43px",
      padding: "8px 15px",
      fontSize: theme.typography.h4.fontSize,
      fontFamily: 'var(--font-family)',
      color: "#FFFFFF",
      textTransform: "none",
      borderRadius: "4px",
      fontWeight: 600,
      //todo: this is not working
      // cursor: disabled === true ? "not-allowed" : "pointer",
    };

    switch (type) {
      case "BrandGradient":
        buttonStyle = {
          ...buttonStyle,
          background: "linear-gradient(84deg, #32376F 0%, #BD00CD 100%)",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
        };
        break;
      case "SmallBrandGradient":
        buttonStyle = {
          ...buttonStyle,
          width: parent_page === "Analytics" ? "70px" : "99px",
          height: parent_page === "Analytics" ? "29px" : "33px",
          padding: "6px 15px",
          fontSize: theme.typography.body1.fontSize,
          background: "linear-gradient(84deg, #32376F 0%, #BD00CD 100%)",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
        };
        break;
      case "BlueFixed":
        buttonStyle = {
          ...buttonStyle,
          background: "#32376F",
        };
        break;
      case "SmallBlueFixed":
        buttonStyle = {
          ...buttonStyle,
          width: "99px",
          height: "33px",
          // todo: make padding responsive
          padding: "6px 15px",
          fontSize: theme.typography.body1.fontSize,
          background: "#32376F",
        };
        break;
      // todo: this is for Feedback, revisit
      // case "Secondary":
      //   buttonStyle = {
      //     ...buttonStyle,
      //     background: "linear-gradient(84deg, #32376F 0%, #BD00CD 100%)",
      //     boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      //     borderRadius: "15px",
      //     // todo: add breakpoints
      //     fontSize: theme.typography.subtitle1.fontSize,
      //     fontWeight: 600,
      //     minWidth: "85px",
      //     height: "25px",
      //   };
      //   break;
      case "Outlined":
        buttonStyle = {
          ...buttonStyle,
          border: "1px solid grey",
          background: "none",
          color: theme.palette.text.primary,
          fontWeight: 400,
        };
        break;
      case "SmallOutlined":
        buttonStyle = {
          ...buttonStyle,
          width: "99px",
          height: "33px",
          padding: "6px 24px",
          fontSize: theme.typography.body1.fontSize,
          border: "1px solid grey",
          background: "none",
          color: theme.palette.text.primary,
          fontWeight: 400,
        };
        break;
      default:
        break;
    }

    return buttonStyle;
  };

  return (
    <>
      {type === "AddNew" ? (
        <Box
          onClick={clickHandler}
          sx={{
            minWidth: "120px",
            height: "32px",
            background: "#6036D6",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            gap: "9px",
            alignItems: "center",
            padding: "8px 12px",
            cursor: "pointer",
          }}
        >
          <AddIcon sx={{ color: "#fff", width: "20px", height: "20px"}}/>
          <Typography variant="body1" sx={{ color: "#FFF", fontFamily: 'var(--font-family)', fontWeight: 500 }}>
            {label}
          </Typography>
        </Box>
      ) : (
        <Button
          onClick={clickHandler}
          disabled={disabled}
          className={className} 
          sx={{
            ...getButtonStyle(),
            // "&:hover":
            // type === "Outlined"
            // //  ? { background: theme.palette.secondary.main }
            //   : undefined,
            "&:hover": {
              backgroundColor:
                type === "SmallBlueFixed" ? "#32376F" : "inherit",
              boxShadow: type === "SmallBlueFixed" ? "none" : undefined,
            },
            "&.Mui-disabled": {
              color: "#FFFFFF !important",
            },
          }}
        >
          {/* Conditional rendering: if type is SmallBrandGradient and no label, display Download icon */}
        {type === "SmallBrandGradient" && !label ? (
          <Download sx={{ width: "20px" }} />
        ) : (
          label // Display label text if provided
        )}
        </Button>
      )}
    </>
  );
};

export default CustomButton;
